import { applyCssStyle } from '@dsee/util/dom.util.js';

export default {
    methods: {
        calculateHidden() {
            const items = this.$refs.container?.children;

            if (!items) return;

            applyCssStyle(this.$el, {
                width: '100%',
            });
            applyCssStyle(this.$refs.container, {
                width: '100%',
            });
            
            const itemCount = items.length;
            const available = this.$refs.container.getBoundingClientRect();

            let index = 0;
            this.hiddenCount = this.elementList.length - this.visibleList.length;

            while (index < itemCount) {
                const item = items[index];
                item.style.display = '';

                const rect = item.getBoundingClientRect();

                if (rect.right > available.right + 1)
                    break;

                index++;
            }

            this.hiddenCount += itemCount - index;

            while (index < itemCount) {
                const item = items[index];
                item.style.display = 'none';
                index++;
            }

            applyCssStyle(this.$el, {
                width: '',
            });
            applyCssStyle(this.$refs.container, {
                width: '',
            });
        },
    },
};
